import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { VisionButtonModule } from '../vision-button/vision-button.module';
import { VisionSelectModule } from '../vision-select/vision-select.module';
import { ProductPickerComponent } from './product-picker/product-picker.component';

@NgModule({
  exports: [ProductPickerComponent],
  imports: [CommonModule, VisionSelectModule, VisionButtonModule, ProductPickerComponent],
})
export class ProductPickerModule {}
